<!-- FEATURES - PRODUCTS SIN TITULO -->
<div *ngIf="type === 'products_links'" class="flex flex-col px-5 mt-5 sm:px-5 md:px-10 lg:px-10 xl:px-20 2xl:px-32">
    <div *ngFor="let item of data">
        <div class="flex-1 mt-10 mb-10 border-t-4 border-gray-200"></div>
        <div class="flex flex-row items-center justify-around bgsigmaprod">
            <div *ngFor="let itemFeatures of item.features" [routerLink]="itemFeatures.url" routerLinkActive="active"
                [routerLinkActiveOptions]="{exact: true}"
                class="flex flex-col items-center justify-center w-full h-auto py-2 mx-1 mb-10 overflow-hidden rounded-lg shadow-lg cursor-pointer divProd md:h-auto md:py-0 sm:mx-3 md:w-1/3 lg:w-56 dark:bg-gray-800 focus:outline-none ">
                <div
                    class="flex items-center justify-center h-16 border w-28 sm:h-24 md:h-28 lg:h-32 sm:w-40 md:w-full">
                    <div
                        class="flex flex-row items-center justify-center h-full px-0 rounded-lg md:h-full w-36 sm:w-64 md:w-full md:rounded-t-lg md:rounded-l-none ">
                        <picture>
                            <source type="image/webp" [attr.defaultImage]="itemFeatures.icon +'.webp'"
                                [attr.lazyLoad]="itemFeatures.icon +'.webp'" />
                            <img [defaultImage]="itemFeatures.icon +'.png'" [lazyLoad]="itemFeatures.icon +'.png'" />
                        </picture>
                    </div>
                </div>
                <div
                    class="flex-col items-start justify-around hidden w-full h-auto px-5 md:flex md:px-0 bg-gray-50 txtProd md:justify-start md:items-center ">
                    <div
                        class="flex flex-row items-start justify-start w-full h-auto py-2 md:justify-center md:h-28 md:px-2">
                        <p class="text-xl text-center lg:text-2xl">
                            {{itemFeatures.title}}</p>
                    </div>
                    <div
                        class="flex flex-row items-center w-full px-0 py-0 md:hidden md:justify-center md:text-center ">
                        <a
                            class="p-2 font-semibold text-white transition-colors duration-200 transform rounded text-md bg-sigma-200 hover:bg-sigma-100 focus:bg-sigma-200 focus:outline-none md:py-1">Conoce
                            más</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- FEATURES - PRODUCTS  -->
<div *ngIf="type === 'products'">
    <div *ngFor="let item of data" class="">
        <app-title-section [title]="item.title" [type]="'title'">
        </app-title-section>
        <div class="flex flex-row items-center justify-around bgsigmaprod">
            <div *ngFor="let itemFeatures of item.features" [routerLink]="itemFeatures.url" routerLinkActive="active"
                [routerLinkActiveOptions]="{exact: true}"
                class="flex flex-col items-center justify-center w-full h-auto py-2 mx-1 mb-10 overflow-hidden rounded-lg shadow-lg cursor-pointer divProd md:h-auto md:py-0 sm:mx-3 md:w-1/3 lg:w-56 focus:outline-none ">
                <div
                    class="flex items-center justify-center h-16 border w-28 sm:h-24 md:h-28 lg:h-32 sm:w-40 md:w-full">
                    <div
                        class="flex flex-row items-center justify-center h-full px-0 rounded-lg md:h-full w-36 sm:w-64 md:w-full md:rounded-t-lg md:rounded-l-none ">
                        <picture>
                            <source type="image/webp" [attr.defaultImage]="itemFeatures.icon +'.webp'"
                                [attr.lazyLoad]="itemFeatures.icon +'.webp'" />
                            <img [defaultImage]="itemFeatures.icon +'.png'" [lazyLoad]="itemFeatures.icon +'.png'" />
                        </picture>
                    </div>
                </div>
                <div
                    class="flex-col items-start justify-around hidden w-full h-auto px-5 md:flex md:px-0 bg-gray-50 txtProd md:justify-start md:items-center ">
                    <div
                        class="flex flex-row items-start justify-start w-full h-auto py-2 md:justify-center md:h-28 md:px-2">
                        <p class="text-xl text-center lg:text-2xl">
                            {{itemFeatures.title}}</p>
                    </div>
                    <div
                        class="flex flex-row items-center w-full px-0 py-0 md:hidden md:justify-center md:text-center ">
                        <a
                            class="p-2 font-semibold text-white transition-colors duration-200 transform rounded text-md bg-sigma-200 hover:bg-sigma-100 focus:bg-sigma-200 focus:outline-none md:py-1">Conoce
                            más</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- FEATURES - CATALOGS PRODUCTS -->
<div *ngIf="type === 'catalogs'" class="w-full">

    <div class="flex flex-col px-5 mt-5 sm:px-5 md:px-10 lg:px-10 xl:px-20 2xl:px-32">
        <app-title-section [title]="'Nuestros productos'" [type]="'title'">
        </app-title-section>
    </div>

    <div class="flex flex-col px-5 mt-5 sm:px-5 md:px-10 lg:px-10 xl:px-20 2xl:px-32">
        <div
            class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-x-8 gap-y-8 bgsigmaprodcat">
            <div *ngFor="let itemCatalog of dataCat?.catalog"
                class="w-full mx-0 overflow-hidden rounded-lg shadow-lg cursor-default h-72 md:h-96 divProdCat bgsigmaprodcatini md:justify-center md:py-0 sm:mx-3 focus:outline-none">
                <div class="flex flex-col items-center justify-start w-full h-32 px-5 md:px-0 txtProd">
                    <div class="flex flex-row items-center justify-center w-full h-full py-2 md:px-2">
                        <p class="mb-5 text-2xl text-center sm:text-2xl ">
                            {{itemCatalog.title}}</p>
                    </div>
                </div>
                <div class="flex items-center justify-center w-full h-64 bg-white md:h-full imgProd">
                    <div
                        class="flex flex-row items-center justify-center w-full h-full pb-24 rounded-l-lg md:rounded-t-lg md:rounded-l-none ">
                        <picture>
                            <source class="w-auto h-56 bg-center bg-no-repeat bg-cover md:w-auto" type="image/webp"
                                [attr.defaultImage]="itemCatalog.icon +'.webp'"
                                [attr.lazyLoad]="itemCatalog.icon +'.webp'" />
                            <img class="w-auto h-56 bg-center bg-no-repeat bg-cover md:w-auto"
                                [defaultImage]="itemCatalog.icon +'.jpg'" [lazyLoad]="itemCatalog.icon +'.jpg'" />
                        </picture>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <br><br><br><br>
</div>

<!-- FEATURES - BRANDS -->
<div *ngIf="type === 'brands'">
    <div *ngFor="let item of data" class="">
        <app-title-section [title]="item.title" [type]="'title'">
        </app-title-section>
        <br>
        <div class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 xl:grid-cols-2 gap-x-10 gap-y-2 ">
            <div *ngFor="let itemFeatures of item.features"
                class="flex flex-col items-center justify-start w-full mx-0 overflow-hidden bg-gray-300 rounded-lg shadow-lg mb-14 md:flex-row">
                <div class="flex items-center justify-center w-full h-full bg-gray-300 md:w-2/5 lg:w-2/5">
                    <div class="flex flex-row items-center justify-center w-full h-full px-5 py-5">
                        <picture class="w-auto h-auto md:h-auto">
                            <source class="bg-center bg-no-repeat bg-cover " type="image/webp"
                                [attr.defaultImage]="itemFeatures.icon +'.webp'"
                                [attr.lazyLoad]="itemFeatures.icon +'.webp'" />
                            <img class="bg-center bg-no-repeat bg-cover " [defaultImage]="itemFeatures.icon +'.png'"
                                [lazyLoad]="itemFeatures.icon +'.png'" />
                        </picture>
                    </div>
                </div>
                <div
                    class="flex flex-row items-start justify-center w-full h-full px-5 bg-white border-b border-gray-300 md:w-3/4 lg:w-3/4 md:justify-start md:items-center md:border-l">
                    <p class="w-full h-full py-5 text-2xl text-justify text-gray-600 md:text-xl lg:text-2xl ">
                        {{itemFeatures.description}}</p>
                </div>
            </div>
        </div>
    </div>
    <br><br>
</div>

<!-- FEATURES - BRANDS -->
<div *ngIf="type === 'brandsMALO'">
    <div *ngFor="let item of data" class="">
        <app-title-section [title]="item.title" [type]="'title'">
        </app-title-section>
        <br>
        <div class="flex flex-col items-center justify-around">
            <div *ngFor="let itemFeatures of item.features"
                class="flex flex-col items-center justify-start w-full h-auto mx-0 overflow-hidden bg-gray-300 rounded-lg shadow-lg md:h-48 lg:h-44 mb-14 md:flex-row">
                <div class="flex items-center justify-center w-full h-full bg-gray-300 md:w-1/4 lg:w-1/4">
                    <div class="flex flex-row items-center justify-center w-full h-full px-5 py-5">
                        &nbsp;
                        <picture>
                            <source class="w-1/2 bg-center bg-no-repeat bg-contain md:w-auto " type="image/webp"
                                [attr.defaultImage]="itemFeatures.icon +'.webp'"
                                [attr.lazyLoad]="itemFeatures.icon +'.webp'" />
                            <img class="w-1/2 bg-center bg-no-repeat bg-contain md:w-auto "
                                [defaultImage]="itemFeatures.icon +'.png'" [lazyLoad]="itemFeatures.icon +'.png'" />
                        </picture>
                    </div>
                </div>
                <div
                    class="flex flex-row items-start justify-center w-full h-full px-5 bg-white border-b border-gray-300 md:w-3/4 lg:w-3/4 md:justify-start md:items-center md:border-l">
                    <p
                        class="w-full py-5 text-2xl text-justify text-gray-600 md:text-xl lg:text-2xl dark:text-gray-400">
                        {{itemFeatures.description}}</p>
                </div>
            </div>
        </div>
    </div>
    <br><br>
</div>

<!-- FEATURES - BRANDS ACCESOS-->
<div *ngIf="type === 'access_brands'" class="flex flex-col px-5 mt-5 sm:px-5 md:px-10 lg:px-10 xl:px-20 2xl:px-32">
    <div *ngFor="let item of data?.brands">
        <app-title-section [title]="item.title" [type]="'title'">
        </app-title-section>
        <div *ngFor="let itemMedia of item.media"
            class="flex flex-col items-center w-full">
            <!-- <img class="" [src]="itemMedia.file" [alt]="itemMedia.title"> -->
            <picture class="block w-max max-w-full">
                <source type="image/webp" [attr.defaultImage]="itemMedia.file +'.webp'"
                    [attr.lazyLoad]="itemMedia.file +'.webp'" />
                <img [defaultImage]="itemMedia.file +'.jpg'" [lazyLoad]="itemMedia.file +'.jpg'" />
            </picture>
        </div>
    </div>
</div>

<!-- FEATURES - ABOUT US -->
<div *ngIf="type === 'aboutus'" class="flex flex-col">
    <div class="flex flex-col w-full" id="scrollabout">
        <app-title-section [title]="data[0]?.title" [type]="'title'">
        </app-title-section>
        <div class="w-full px-0 mb-10 md:px-5">
            <p class="mb-8 text-xl text-justify text-gray-800 md:mb-10 md:text-2xl lg:text-2xl">
                {{data[0]?.description}}
            </p>
            <picture class="block w-full overflow-hidden rounded-lg shadow-lg">
                <source type="image/webp" [attr.defaultImage]="data[0]?.img +'.webp'"
                    [attr.lazyLoad]="data[0]?.img +'.webp'" />
                <img [defaultImage]="data[0]?.img +'.png'" [lazyLoad]="data[0]?.img +'.png'"
                    class="block h-auto w-full"
                    alt="Instalaciones, oficinas y almacenes" />
            </picture>
        </div>
    </div>
    <div class="flex flex-row flex-wrap items-start justify-around px-0 md:px-5" id="scrollmission">
        <div class="flex flex-row items-center w-full mb-10 md:pr-10 md:w-1/2">
            <div class="flex flex-col w-full">
                <app-title-section [title]="data[1]?.title" [type]="'title'">
                </app-title-section>
                <p class="text-xl text-justify text-gray-800 md:text-2xl">
                    {{data[1]?.description}}
                </p>
            </div>
        </div>
        <div class="flex flex-row items-center w-full mb-10 md:pl-10 md:w-1/2">
            <div class="flex flex-col w-full">
                <app-title-section [title]="data[2]?.title" [type]="'title'">
                </app-title-section>
                <p class="text-xl text-justify text-gray-800 md:text-2xl">
                    {{data[2]?.description}}
                </p>
            </div>
        </div>
    </div>
</div>